<div class="avatar">
    {{ initials }}
</div>
